import { styled } from '@volkswagen-onehub/components-core';

export const RemoveVehicleContainer = styled.div`
  width: 100%;
`;
